/** {@code act_jobs.job_status}: View Jackets lists only {@code O} and {@code R}. */
export function isJacketJobStatusOpenOrClosed(status) {
  const st = String(status ?? "").trim().toUpperCase();
  return st === "O" || st === "R";
}

/** Filter jacket job rows from GET .../jacket-jobs (or equivalent). */
export function filterJacketJobsOpenOrClosed(jobs) {
  if (!Array.isArray(jobs)) {
    return [];
  }
  return jobs.filter((job) => isJacketJobStatusOpenOrClosed(job?.status));
}
